var React = require('react');

// components
var RestrictedContent = require('../RestrictedContent/RestrictedContent');
var VideoMembershipOverlay = require('../VideoMembershipOverlay/VideoMembershipOverlay');

class RestrictedComponent extends React.Component {
	render() {
		const TagName = this.props.isVideo ? VideoMembershipOverlay : RestrictedContent;
		return <TagName hasAccess={this.props.hasAccess} children={this.props.children} className={this.props.className} />
	}
}

module.exports = RestrictedComponent;


// WEBPACK FOOTER //
// ./src/common/RestrictedComponent/RestrictedComponent.js